import { useState } from 'react';

const defaultFilters = (buildingId) => ({
  buildings: buildingId ? [buildingId] : [],
  date: null,
});

/**
 * Helper state for a buildings + dates context, used by the dashboard and changelog pages
 * Includes an organization id so that super-admins can look at other orgs' pages
 */
const useDatedBuildings = ({ buildingId }) => {
  const [filters, setFilters] = useState(defaultFilters(buildingId));
  const resetFilters = () => setFilters(defaultFilters());
  return [filters, setFilters, resetFilters];
};

export default useDatedBuildings;
